import React, { FC, ReactNode } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';

export const StoreActionsCard: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Box justify="center" align="center" padding="0.75rem 0 0.5rem">
      {children}
    </Box>
  );
};
